import {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import './SuperAdminLeadStatus.css'
import LeadStatusService from '../../../api/super-admin/LeadStatusService'
import { LeadStatus, LeadStatusPost, LeadStatusUpdate } from '../../models/SuperAdminLeadStatus'
import ReactPaginate from 'react-paginate'

interface Errors {
  title: string;
}

function SuperAdminLeadStatus() {

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [leadStatusList, setLeadStatusList] = useState<LeadStatus[]>([] as LeadStatus[]);
  const [formData, setFormData] = useState<any>({ id: undefined, title: '' })
  const [formErrors, setFormErrors] = useState<Errors>({ title: '' });

  useEffect(() => {
    getLeadStatusList()
  }, [])

  const getLeadStatusList = () => {
    LeadStatusService.getLeadStatusList().then(
      (res: any) => {
        if (res?.data?.success) {
          setLeadStatusList(res?.data?.data)
        } else {
          setLeadStatusList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {name, value} = e.target
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }))

    const { isValid, errors } = validateFormData();
    if (!isValid) {
      setFormErrors((prevErrors) => ({...prevErrors, ...errors}));
    }
  }

  const clearFormData = () => {
    setFormData({
      id: undefined,
      title: ''
    })
  }

  const handleAdd = () => {
    clearFormData()
    setIsEdit(false)
    setShowPopup(true)
  }

  const handleEdit = (leadStatus: LeadStatus) => {
    setFormData({id: leadStatus.id, title: leadStatus.title})
    setIsEdit(true);
    setShowPopup(true)
  }

  const validateFormData = () => {
    // Clear previous errors
    setFormErrors({ title: '' });

    // Validation checks
    let errors: Errors = { title: '' };
    let isValid = true;
  
    if (!formData.title.trim()) {
      errors.title = 'Title is required';
      isValid = false;
    }
  
    return {isValid, errors};
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const { isValid, errors } = validateFormData();
    if (!isValid) {
      setFormErrors((prevErrors) => ({...prevErrors, ...errors}));
      return;
    }

    if (!isEdit) {      
      let data: LeadStatusPost = {
        title: formData?.title,
      }
      LeadStatusService.addLeadStatus(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowPopup(false)
            clearFormData()
            getLeadStatusList()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
    else {
      let data: LeadStatusUpdate = {
        id: formData?.id!,
        title: formData?.title,
      }
      LeadStatusService.updateLeadStatus(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowPopup(false)
            clearFormData()
            getLeadStatusList()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }

  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        LeadStatusService.deleteLeadStatus(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getLeadStatusList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  const handleStatusToggle = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        LeadStatusService.changeLeadStatus(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getLeadStatusList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  return (
    <>
      {/* <div className='text-lg-end'>
        <button type='button' className='btn btn-primary px-5 py-3' onClick={handleAdd}>
          + Add Lead Status
        </button>
      </div> */}
      {/* Table */}
      <div className='col-lg-12' style={{marginTop: -10}} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Title</span>
            </td>
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Status</span>
            </td>
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {leadStatusList.map((leadStatus: LeadStatus, index: number) => (
            (leadStatus.status === 1 || leadStatus.status === 2) &&
            <div
              className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
              key={index}
              style={{marginBottom: 20, borderRadius: 5}}
            >
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {leadStatus.title}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className={`fw-bold d-block fs-5 d-flex align-items-center ${leadStatus.status===1? 'text-success' : 'text-danger'}`}>
                  {leadStatus.status === 1 ? 'Active' : 'In-active'}
                </span>
              </td>
              <td className='d-flex justify-content-end w-lg-25'>
                <button
                  type='button'
                  onClick={() => handleEdit(leadStatus)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Edit'
                >
                  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                </button>
                <button
                  onClick={() => handleDelete(leadStatus?.id)}
                  type='button'
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Delete'
                >
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                </button>
                <div className='d-flex justify-content-end flex-shrink-0 mx-1'>
                  {leadStatus.status === 1 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder active-status'
                        onClick={() => handleStatusToggle(leadStatus.id)}
                      >
                        <div className='d-flex align-items-center justify-content-end'>
                          <div className='active-user active-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                  {leadStatus.status === 2 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder pending-status'
                        onClick={() => handleStatusToggle(leadStatus.id)}
                      >
                        <div className='d-flex align-items-center'>
                          <div className='active-user pending-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </div>
          ))}
        </div>
      </div>
      {/* Add / Edit Popup */}
      {showPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='d-flex justify-content-between align-items-center w-100 mx-3'>
                <h5 className='modal-title'>{isEdit ? 'Update Lead Status' : 'Add Lead Status'}</h5>
                <button className='btn btn-close' onClick={() => {
                  setFormErrors({ title: '' })
                  setShowPopup(false)
                }}></button>
              </div>
              <div className='modal-body' style={{ width: '100%'}}>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className='row mb-3'>
                    <div className='form-group col'>
                      <label style={{fontSize:14, margin:5}} htmlFor='fullName'>Title</label>
                      <input
                        type='text'
                        id='title'
                        name='title'
                        className={`form-control ${formErrors.title && 'is-invalid'}`}
                        value={formData.title}
                        onChange={handleInputChange}
                      />
                      {formErrors.title && <div className='invalid-feedback'>{formErrors.title}</div>}
                    </div>
                  </div>
                  <div className='text-end'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 25}}>
                      {isEdit ? 'Update' : 'Add'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SuperAdminLeadStatus
